'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { Row, Col, Container, Button } from 'reactstrap';
import CtaBtn from 'shared/components/CtaBtn';
import AppLayout from '../../../components/AppLayout';
import { getI18nUtils } from 'shared/i18n/i18n-utils';
import { Dictionaries, Locale } from 'shared/i18n/i18n-config';
import { useRouter } from 'next/navigation';
import Link from 'next/link';

type Props = {
  dictionary: Partial<Dictionaries>;
  locale: Locale;
};
export default function JumpToSynergie({ locale, dictionary }: Props) {
  const { formatMessage } = getI18nUtils(dictionary);
  const { push } = useRouter();

  const handleClick = (url: string) => {
    push(url);
  };
  return (
    <AppLayout
      dictionary={dictionary}
      className="jumpToSynergiePage"
      availableLocales={[{ locale: 'nl', pathname: '/jump-to-synergie' }]}
    >
      {/* INTRO: "Maak je sprong" + CTA */}
      <Container tag="section" className="py-md-5 mb-md-3 my-5">
        <Col sm={12} lg={{ offset: 3, size: 6 }}>
          <h1 className="py-2 mb-4">{formatMessage({ id: 'jumptosynergie_intro_title' })}</h1>
          <p>{formatMessage({ id: 'jumptosynergie_intro' })}</p>
          <Button onClick={() => handleClick('#consultantsTrack')} outline className="px-4 my-3 me-2">
            {formatMessage({ id: 'hr_consultant' })}
          </Button>
          <Button onClick={() => handleClick('#managersTrack')} outline className="px-4 my-3">
            {formatMessage({ id: 'office_manager' })}
          </Button>
        </Col>
      </Container>
      <div className="bg-light">
        <section>
          <Container fluid id="consultantsTrack" tag="section">
            <Row className="align-items-center">
              <Col sm={12} lg={6} className="d-flex justify-content-center my-4 p-3 p-md-4">
                <div className="text-block">
                  <h2 className="mb-4">{formatMessage({ id: 'hr_consultant' })}</h2>
                  <hr className="my-4 pe-5" />
                  <p>{formatMessage({ id: 'jumptosynergie_consultants_p' })}</p>
                  <Link href={`/${locale}/jump-to-synergie/consultants/`}>
                    <CtaBtn className="cta red mt-3" type="button">
                      {formatMessage({ id: 'jumptosynergie_cta_more_info' })}
                    </CtaBtn>
                  </Link>
                </div>
              </Col>
              <Col sm={12} lg={6} className="h-100 p-0">
                <picture>
                  <source media="(max-width: 992px)" srcSet="/images/jump-to-synergie/jump_consultants_mobile.jpg" />
                  <source media="(min-width: 769px)" srcSet="/images/jump-to-synergie/jump_consultants.jpg" />
                  <img src="/images/jump-to-synergie/jump_consultants.jpg" alt="Synergie collega's" className="img-fluid " />
                </picture>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <div>
        <section>
          <Container fluid id="managersTrack" tag="section">
            <Row className="align-items-center">
              <Col sm={12} lg={{ size: 6, order: 2 }} className="d-flex justify-content-center my-4 p-3 p-md-4">
                <div className="text-block">
                  <h2 className="mb-4">{formatMessage({ id: 'office_manager' })}</h2>
                  <hr className="my-4 pe-5" />
                  <p>{formatMessage({ id: 'jumptosynergie_managers_p' })}</p>
                  <Link href={`/${locale}/jump-to-synergie/managers/`}>
                    <CtaBtn className="cta red mt-3" type="button">
                      {formatMessage({ id: 'jumptosynergie_cta_more_info' })}
                    </CtaBtn>
                  </Link>
                </div>
              </Col>
              <Col sm={12} lg={{ size: 6, order: 1 }} className="h-100 p-0">
                <picture>
                  <source media="(max-width: 992px)" srcSet="/images/jump-to-synergie/jump_managers_mobile.jpg" />
                  <source media="(min-width: 769px)" srcSet="/images/jump-to-synergie/jump_managers.jpg" />
                  <img
                    src="/images/jump-to-synergie/jump_managers.jpg"
                    alt="Vrouw neemt interview af"
                    className="img-fluid mx-0"
                  />
                </picture>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </AppLayout>
  );
}
